import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { useAdjust } from "../../hook/useAdjust";
import {
	authenticatePrepareLogin,
	setCredentialFlowStep,
	socialMediaAuthenticateRequest,
} from "../../store/modules/auth/actions";

import { Container, Content, ContainerButton, FormGroupInput, PasswordEye, Title } from "./styles";
import { waitTimeout } from "../../utils";

import Button from "../../shared/components/Button";
import Input from "../../shared/components/Input";
import history from "../../services/history";
import { STEP } from "../../shared/constants";

const FormLoginCheckout = () => {
	const dispatch = useDispatch();

	const { loading, loginFail, respError, credentialFlowStep } = useSelector((state) => state.auth);

	const { adid } = useAdjust();

	const { getValues, handleSubmit, register } = useForm();

	const [hidePassword, setHidePassword] = useState(true);
	const [step, setStep] = useState(STEP.GO_TO);

	const error = useMemo(
		() => (loginFail || respError ? "E-mail ou senha incorretos, revise e tente novamente" : ""),
		[loginFail, respError]
	);

	useEffect(() => {
		if (loginFail || respError) {
			handleStep(STEP.LOGIN);
		}
	}, [loginFail, respError]);

	useEffect(() => {
		if (credentialFlowStep != step) {
			handleStep(credentialFlowStep);
		}
	}, [credentialFlowStep]);

	function authenticate() {
		const { document, password } = getValues();

		const uriParams = new URLSearchParams(window.location.search);
		const sso = uriParams.get("sso");
		const sig = uriParams.get("sig");
		const entries = Object.fromEntries(uriParams) || [];
		const options = Boolean(entries.length);

		if (sso !== null && sig !== null) {
			dispatch(socialMediaAuthenticateRequest(formatDocument(document), password, sso, sig));
		} else {
			dispatch(
				authenticatePrepareLogin(
					formatDocument(document),
					password,
					false,
					options,
					false,
					adid
				)
			);
			history.push("/onboard/prepare-login");
		}
	}

	function formatDocument(document) {
		if (!document.includes("@")) {
			return document.trim().replace(/\.|-|[()]|[+]|[ ]/g, "");
		}
		return document.trim().toLowerCase();
	}

	/**
	 *
	 * @param {"REGISTER" | "LOGIN"} route
	 */
	function goTo(route) {
		const pathDefault = "/onboard/";
		const action = {
			REGISTER: () => {
				localStorage.setItem("appflow", route);
				history.push(pathDefault + "welcome");
			},
			RECOVER: () => {
				history.push(pathDefault + "recover-account");
			},
		};

		action[route]();
	}

	async function handleStep(step) {
		setStep(step);
		dispatch(setCredentialFlowStep(step));
		await waitTimeout(200);

		const element = document.getElementById("login-checkout");

		if (element) {
			element.scrollIntoView({
				behavior: "smooth",
			});
		}
	}

	if (step === STEP.GO_TO) {
		return (
			<Container id="login-checkout">
				<Content>
					<form>
						<Title className="hide-mobile">
							Deixe o TradeMap te ajudar a dar o próximo passo
						</Title>

						<ContainerButton>
							<Button
								title="Criar uma conta"
								onClick={() => goTo("REGISTER")}
							></Button>
							<Button
								title="Já tem uma conta? Clique aqui"
								btnType="fill"
								onClick={() => handleStep(STEP.LOGIN)}
							></Button>
						</ContainerButton>
					</form>
				</Content>
			</Container>
		);
	}

	return (
		<Container id="login-checkout">
			<Content>
				<form onSubmit={handleSubmit(authenticate)}>
					<Title>Faça login ou crie conta para continuar</Title>
					<FormGroupInput>
						<Input
							label="E-mail, CPF ou celular"
							name="document"
							id="document"
							errorMessage={error}
							onFocus={(e) =>
								e.target.removeAttribute("readonly")
							}
							fieldRegister="document"
							register={register}
						/>
					</FormGroupInput>
					<FormGroupInput>
						<div>
							<Input
								label="Senha"
								id="password"
								name="password"
								type={
									hidePassword
										? "password"
										: "text"
								}
								errorMessage={error}
								register={register}
								fieldRegister="password"
							/>

							<PasswordEye
								error={loginFail}
								onClick={() =>
									setHidePassword(!hidePassword)
								}
							>
								{hidePassword ? (
									<MdVisibility size={24} />
								) : (
									<MdVisibilityOff size={24} />
								)}
							</PasswordEye>
						</div>
					</FormGroupInput>
					<ContainerButton className="mt-5">
						<Button
							title="Entrar e continuar"
							type="submit"
							loading={loading}
						></Button>
						<Button
							title="Criar uma conta"
							btnType="outline"
							onClick={() => goTo("REGISTER")}
						></Button>
						<Button
							title="Esqueci a senha"
							btnType="fill"
							onClick={() => goTo("RECOVER")}
						></Button>
					</ContainerButton>
				</form>
			</Content>
		</Container>
	);
};

export default FormLoginCheckout;
